import React from 'react';
import { UserIcon, BuildingOfficeIcon, BriefcaseIcon } from '@heroicons/react/24/outline';

interface PrivacyTogglesProps {
  includeName: boolean;
  includeCompany: boolean;
  includeRole: boolean;
  onNameChange: (value: boolean) => void;
  onCompanyChange: (value: boolean) => void;
  onRoleChange: (value: boolean) => void;
}

const PrivacyToggles: React.FC<PrivacyTogglesProps> = ({
  includeName,
  includeCompany,
  includeRole,
  onNameChange,
  onCompanyChange,
  onRoleChange,
}) => {
  const ToggleSwitch = ({ 
    label, 
    icon, 
    checked, 
    onChange 
  }: { 
    label: string; 
    icon: React.ReactNode; 
    checked: boolean; 
    onChange: (value: boolean) => void;
  }) => {
    return (
      <div className="flex items-center justify-between py-2">
        <div className="flex items-center gap-2">
          <div className="text-gray-500 w-5 h-5">
            {icon}
          </div>
          <span className="text-sm font-medium text-gray-700">{label}</span>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          onClick={() => onChange(!checked)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            ${checked ? 'bg-indigo-600' : 'bg-gray-200'}
            focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
          `}
        >
          <span className="sr-only">{label}</span>
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition-transform
              ${checked ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>
    );
  };

  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Privacy Settings
      </label>
      <div className="bg-gray-50 rounded-lg px-4 py-2">
        <ToggleSwitch
          label="Name"
          icon={<UserIcon />}
          checked={includeName}
          onChange={onNameChange}
        />
        <ToggleSwitch
          label="Company"
          icon={<BuildingOfficeIcon />}
          checked={includeCompany}
          onChange={onCompanyChange}
        />
        <ToggleSwitch
          label="Role"
          icon={<BriefcaseIcon />}
          checked={includeRole}
          onChange={onRoleChange}
        />
      </div>
    </div>
  );
};

export default PrivacyToggles;